import UserRepository from '../../../../src/api/repositories/UserRepository';
import Vue from 'vue';
const USER_TYPE_ADMIN = 'dev'


const retrieveUser = () => {
    return window.me || {}
}



let USER_MODEL = {
    id: null,
    username: '',
    email: '',
    phone: '',
    address: '',
    birthday: '',
    company: '',
    subscription: false
    
}

let initialUserData = retrieveUser()

if (initialUserData) {
    USER_MODEL = {...USER_MODEL, ...initialUserData}
}

export default {
    namespaced: true,
    state: {
        user: USER_MODEL,
        unreadInboxMessages: 0,
        inactivitySettings: window.inactivitySettings,
        userBundleIds :[],
        stats: null,
        isEUCustomer: window.DP_EU,
        usertoken: window.usertoken || null,
        pendingInvoicesFlag: false,
        trialExpiredFlag: false,
        onTrial: false,
        latestCourse: false
    },
    getter: {

    },
    actions: {
        setUnreadInboxMessages( {commit} , payload) {
            commit('setUnreadInboxMessages',payload);
        },
        setUserDataForBundles({commit, state} , payload) {
            commit("setUserDataForBundles",payload);
        },
        getUserStats({commit, rootState}, payload){
            UserRepository.getStats().then( response => {                
                if(!response.data.me){
                    return;
                }

                commit('setUserStats', {
                    courses: response.data.userCourses.length,                 
                    certificates: parseInt(response.data.me.certifications.length ),
                    ...response.data.me.stats
                });
            });
        },
        setPendingInvoicesFlag({commit}, payload){
            commit("setPendingInvoicesFlag", payload);
        },
        setTrialExpiredFlag({commit}, payload){
            commit("setTrialExpiredFlag", payload);
        },
        setOnTrial({commit}, payload){
            commit("setOnTrial", payload);
        },
        setLatestCourse({commit}, payload){
            commit("setLatestCourse", payload);
        }
    },
    mutations: {
        setUnreadInboxMessages( state , count) {
            state.unreadInboxMessages = count;
        },
        setUserStats( state, value){            
            Vue.set(state, 'stats' , value);
        },
        setUserDataForBundles (state,bundleIds) {
            state.userBundleIds = bundleIds;
        },
        setPendingInvoicesFlag(state, value) {
            state.pendingInvoicesFlag = value;
        },
        setTrialExpiredFlag(state, value) {
            state.trialExpiredFlag = value;
        },
        setOnTrial(state, value) {
            state.onTrial = value;
        },
        setLatestCourse(state, value) {
            state.latestCourse = value;
        }
    },
    getters: {
        isAdmin (state) {
            return state.user && state.user.usertype === USER_TYPE_ADMIN
        },
        isLoggedIn(state) {
            return (!!state.user.id);
        },
        isAffiliate(state) {
            return state.user?.isAffiliate;
        },
        isAnalytics (state) {
            return !!state.user?.isAnalytics;
        },
        isInstructor(state) {
            return state.user?.isAInstructor;
        },
        /**
         * @returns null if not an instructor, array with courses if he is instructor
         */
        isInstructorIn(state) {
            return state.user?.isInstructorIn;
        },
    }
}